import React from "react";

const HtmlContent = ({ as: Component = "span", html = "", ...props }) => (
  <Component {...props} dangerouslySetInnerHTML={{ __html: String(html || "") }} />
);

export default HtmlContent;
